import { LpLoadingOverlay } from "~/design-system";
const listLoadingOverlaySelector = "[data-lp-list-loading-overlay]";
export function getListResultsElement(root) {
    return root?.querySelector?.("#list-results") ?? null;
}
export function showLoadingOverlay(element, label = "Loading...") {
    element.classList.add("lp-loading-overlay-host");
    if (element.querySelector(listLoadingOverlaySelector)) {
        return;
    }
    element.insertAdjacentHTML("afterbegin", String(LpLoadingOverlay({
        label,
        loaderLabel: label.replace(/\.+$/, ""),
        className: "list-page-loading-state",
        attributes: {
            "data-lp-list-loading-overlay": true,
        },
    })));
}
export function hideLoadingOverlay(element) {
    element.querySelector(listLoadingOverlaySelector)?.remove();
    element.classList.remove("lp-loading-overlay-host");
}
export function startListLoading(_host, root) {
    const listResults = getListResultsElement(root);
    if (listResults) {
        showLoadingOverlay(listResults);
    }
}
export function stopListLoading(_host, root) {
    const listResults = getListResultsElement(root);
    if (listResults) {
        hideLoadingOverlay(listResults);
    }
    const content = document.getElementById("content");
    if (content) {
        hideLoadingOverlay(content);
    }
}
